export const CASE_STUDIES = [
  {
    name: "VictorFi",
    category: "Embedded Payments Infrastructure",
    desc: "Payments infrastructure connecting banks and fintechs through secure APIs, multiple payment rails, virtual accounts and platform tools.",
  },
  {
    name: "LeafLink",
    category: "B2B Commerce & Payments",
    desc: "Payment and operational infrastructure supporting a specialized B2B commerce ecosystem.",
  },
  {
    name: "Skyway Payments",
    category: "Global Payment Processing",
    desc: "Payment processing infrastructure supporting global payments, collections, virtual accounts and settlements.",
  },
  {
    name: "Payrock",
    category: "Payment Gateway & Switching",
    desc: "Greenfield payment infrastructure with gateway integrations, custom connectors, payment switching and account management.",
  },
  {
    name: "NewUlife",
    category: "Global Payments",
    desc: "Stored-value accounts, checkout and global payment capabilities for a worldwide business network.",
  },
  {
    name: "BVNK",
    category: "Digital Asset Payments",
    desc: "Payment infrastructure supporting multi-currency wallets, global payouts, settlements, FX and compliance.",
  },
];

export const PLATFORMS = [
  {
    id: "zenpay",
    name: "ZenPay",
    subtitle: "Neo-Banking & Payments Platform",
    desc: "A PCI-certified, multi-tenant neo-banking platform with a white-label payment gateway at its core, connecting businesses with diverse payment rails and banking capabilities.",
    capabilities: [
      "Multi-currency accounts",
      "Payment gateway",
      "Card acquiring",
      "Recurring payments",
      "Payouts & disbursements",
      "White-label experience",
      "Merchant dashboards",
      "PCI-certified security",
    ],
    cta: "Explore ZenPay",
    to: "/platforms/zenpay",
  },
  {
    id: "emulation",
    name: "Emulation Platform",
    subtitle: "Bank Transfer Automation",
    desc: "Automate bank-transfer workflows and reduce dependency on engineering teams through intelligent bank emulation technology.",
    capabilities: [
      "Bank integration automation",
      "No-code bank configuration",
      "Error detection",
      "Error analysis",
      "Auto-healing",
      "Production-ready changes",
    ],
    cta: "Explore Platform",
    to: "/platforms/emulation",
  },
  {
    id: "wallet",
    name: "Wallet Platform",
    subtitle: "Multi-Tenant Issuer Infrastructure",
    desc: "A configurable wallet and issuer platform designed for multi-currency, multi-tenant financial products.",
    capabilities: [
      "Wallet management",
      "Multi-currency",
      "Card issuance",
      "ACH & Wire",
      "P2P transfers",
      "Merchant portals",
      "Disbursements",
      "60+ connectors",
    ],
    cta: "Explore Platform",
    to: "/platforms/wallet",
  },
];

export const SOLUTION_GROUPS = [
  {
    num: "01",
    title: "Payment Engineering",
    items: [
      "Payment gateway development",
      "Payment processing",
      "Payment orchestration",
      "Payment integrations",
      "Acquiring",
      "Payouts",
      "Wallets",
      "Card solutions",
    ],
  },
  {
    num: "02",
    title: "Banking & Financial Infrastructure",
    items: [
      "Banking integrations",
      "Account validation",
      "Wallet infrastructure",
      "Ledger services",
      "FX integrations",
      "Financial APIs",
    ],
  },
  {
    num: "03",
    title: "Product Engineering",
    items: [
      "Frontend & backend",
      "Mobile applications",
      "API development",
      "System integration",
      "Cloud & infrastructure",
      "QA & certification",
    ],
  },
  {
    num: "04",
    title: "Modernization",
    items: [
      "Payment system migration",
      "Legacy modernization",
      "Automation",
      "Platform optimization",
      "Integration modernization",
    ],
  },
];

export const SECURITY_CAPABILITIES = [
  { title: "Encryption", desc: "Protect sensitive payment information." },
  { title: "Access Control", desc: "Secure role-based platform access." },
  { title: "API Gateway", desc: "Controlled and secure service connectivity." },
  { title: "Audit Logs", desc: "Maintain visibility into critical activity." },
  { title: "Monitoring", desc: "Observe platform and transaction behavior." },
  { title: "Compliance", desc: "Build with financial industry requirements in mind." },
];
